import VeilederBarnestipendDto from '../Models/VeilederBarnestipendDto';
import contentResolver from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import React from 'react';

interface ResultatSectionComponentProps {
    verdi: string;
    ar: string;
    tekst: keyof VeilederBarnestipendDto;
    epiContext: EpiContext<VeilederBarnestipendDto>;
    underElement?: JSX.Element;
}

export const ResultatSectionComponent = (props: ResultatSectionComponentProps): JSX.Element => {
    return (
        <div className="c-veileder__resultat-section">
            <div>
                {contentResolver(props.epiContext, props.tekst)} {props.ar}
            </div>
            <div className="c-veileder__underresultat-tekst">
                {props.verdi}
                <span className="c-veileder__tekst c-veileder__tekst--postfix"> {props.epiContext.valuta}</span>
            </div>
            {props.underElement}
        </div>
    );
};
